import rfStore from "@/utils/rfStore";
import { useEffect, useState } from "react";

export default function useTheme() {
	const [theme, setTheme] = useState(rfStore.getRFState()?.theme || "dark");

	useEffect(() => {
		const updateTheme = () => {
			const newTheme = document.documentElement.getAttribute("data-theme");
			if (newTheme) {
				setTheme(newTheme);
			}
		};

		// 初始设置
		updateTheme();

		// 创建一个观察器实例
		const observer = new MutationObserver(updateTheme);

		// 配置观察器：只观察 `data-theme` 属性的变化
		const config = { attributes: true, attributeFilter: ["data-theme"] };

		// 传入目标节点和观察器的配置
		observer.observe(document.documentElement, config);

		// 清理函数：停止观察
		return () => observer.disconnect();
	}, []);

	return theme;
}
